<template>
	<span tabindex="0" class="inline-block">
		<slot />
	</span>
</template>
